const cardData = [
  {
    id: 1,
    title: '2026暑期档追剧指南',
    desc: '整理妖精视频、桃花视频暑期档全部上线新剧，包括暗夜追凶、长安秘事录等热门剧集排播时间表。',
    tag: '追剧攻略',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20entertainment%20guide%20visual%2C%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20posters%2C%20soft%20warm%20lighting%20with%20coral%20accents%2C%20modern%20home%20theater%20setup%2C%20relaxed%20viewing%20atmosphere%2C%20clean%20lifestyle%20editorial%20composition%2C%20premium%20comfortable%20aesthetic&width=400&height=250&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑剧爱好者必看清单',
    desc: '从妖精视频独播悬疑大剧到苹果视频口碑探案剧，为你盘点今年最值得追的烧脑悬疑佳作。',
    tag: '类型盘点',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20visual%20with%20dramatic%20lighting%2C%20close-up%20of%20evidence%20board%20with%20red%20strings%20and%20photos%2C%20warm%20amber%20desk%20lamp%20illumination%2C%20noir%20atmospheric%20office%20scene%2C%20cinematic%20suspense%20aesthetic%2C%20clean%20dark%20composition%20with%20warm%20highlights%2C%20premium%20detective%20genre%20visual&width=400&height=250&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '榴莲视频 + 豆花视频资源整合',
    desc: '两大平台热门影视一键聚合，不再需要多个应用来回切换，一个页面全网追剧，资源覆盖更全面。',
    tag: '平台聚合',
    img: 'https://readdy.ai/api/search-image?query=Digital%20media%20aggregation%20concept%20visual%2C%20multiple%20floating%20smartphone%20screens%20showing%20different%20streaming%20apps%20merging%20into%20one%2C%20warm%20coral%20gradient%20background%2C%20modern%20tech%20connection%20aesthetic%2C%20clean%20minimal%20UI%20design%20elements%2C%20premium%20digital%20platform%20visualization&width=400&height=250&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '新用户追剧入门完全指南',
    desc: '从注册到找剧一站式教学，涵盖妖精视频、桃花视频、苹果视频等平台热播剧查找技巧和追剧效率提升方法。',
    tag: '新手入门',
    img: 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20guide%20visual%2C%20clean%20modern%20desk%20with%20laptop%20and%20notebook%2C%20warm%20soft%20natural%20lighting%2C%20organized%20workspace%20with%20streaming%20interface%20on%20screen%2C%20welcoming%20learning%20atmosphere%2C%20minimal%20pastel%20coral%20tones%2C%20premium%20tutorial%20editorial%20photography&width=400&height=250&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '高清画质对比：1080P追剧体验',
    desc: '实测嫩草视频聚合的各平台资源画质表现，妖精视频和桃花视频的1080P清晰度谁更胜一筹？追剧体验全维度对比。',
    tag: '体验评测',
    img: 'https://readdy.ai/api/search-image?query=High%20definition%20video%20quality%20comparison%20visual%2C%20split%20screen%20displaying%20cinematic%20content%20on%20modern%20monitor%2C%20warm%20professional%20studio%20lighting%2C%20crisp%20clean%20image%20quality%20demonstration%2C%20premium%20tech%20review%20aesthetic%2C%20minimal%20editorial%20composition%20with%20coral%20accents&width=400&height=250&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-article-line"></i>
            实用指南
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            追剧指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            最新的追剧攻略、平台资讯和观影技巧，帮你更高效地享受全网影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardData.slice(0, 3).map((card) => (
            <div key={card.id} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium mb-3 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-foreground-950 font-medium text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}

          <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {cardData.slice(3).map((card) => (
              <div key={card.id} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group flex flex-col sm:flex-row">
                <div className="sm:w-2/5 aspect-[16/10] sm:aspect-auto bg-background-200 overflow-hidden flex-shrink-0">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex-1 flex flex-col justify-center">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium mb-2 whitespace-nowrap w-fit">
                    {card.tag}
                  </span>
                  <h3 className="text-foreground-950 font-medium text-sm mb-1.5 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}